<template>
  <div id="app">

    <!-- 🔥 1. VIDEO -->
    <template v-if="pantalla === 'inicio'">
      <InicioLogo 
        v-if="isSmallScreen"
        @termino-video="irAPreguntar"
      />
      <PantallaG v-else />
    </template>

    <!-- 🔥 2. PREGUNTAR -->
    <template v-else-if="pantalla === 'preguntar'">
      <Preguntar 
        :id-invitado="idInvitado"
        :nombre="nombreFestejado"
        :id-festejado="idFestejado"
        @idioma-seleccionado="establecerIdioma" 
      />
    </template>

    <!-- 🔥 3. CONTENIDO -->
    <template v-else-if="pantalla === 'contenido'">

      <!-- ESPAÑOL -->
      <template v-if="idiomaSeleccionado === 'es'">
        <Componentep 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
          :id-festejado="idFestejado"
          :nombre="nombreFestejado"
        />
        <PantallaG v-else />
      </template>

      <!-- INGLÉS -->
      <template v-else-if="idiomaSeleccionado === 'en'">
        <ComponentePingles 
          v-if="isSmallScreen"
          :id-invitado="idInvitado"
          :id-festejado="idFestejado"
          :nombre="nombreFestejado"
        />
        <PantallaG v-else />
      </template>

    </template>

  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import InicioLogo from './components/inicio.vue'
import Preguntar from './components/preguntar.vue'
import Componentep from './components/contenedor.vue'
import ComponentePingles from './components/ingles/contenedor_ingles.vue'
import PantallaG from './components/pantallas_g.vue'

export default {
  components: {
    InicioLogo,
    Preguntar,
    Componentep,
    ComponentePingles,
    PantallaG,
  },
  setup() {
    const route = useRoute()

    // Extraemos los datos de la ruta URL
    const idInvitado = ref(Number(route.params.idInvitado) || undefined)
    const nombreFestejado = ref(route.params.nombre || route.params.nombreFestejado || '')
    const idFestejado = ref(Number(route.params.idFestejado) || undefined)

    const isSmallScreen = ref(window.innerWidth < 768)
    const pantalla = ref('preguntar') 
    const idiomaSeleccionado = ref(null)

    const irAPreguntar = () => {
      pantalla.value = 'preguntar'
    }

    const establecerIdioma = (idioma) => {
      idiomaSeleccionado.value = idioma
      pantalla.value = 'contenido'
    }

    // Escuchamos si cambian las variables en la URL
    watch(() => route.params, (newParams) => {
      idInvitado.value = Number(newParams.idInvitado) || undefined
      nombreFestejado.value = newParams.nombre || newParams.nombreFestejado || ''
      idFestejado.value = Number(newParams.idFestejado) || undefined
    }, { deep: true })

    window.addEventListener('resize', () => {
      isSmallScreen.value = window.innerWidth < 768
    })

    return {
      idInvitado,
      nombreFestejado,
      idFestejado,
      isSmallScreen,
      pantalla,
      idiomaSeleccionado,
      irAPreguntar,
      establecerIdioma,
    }
  }
}
</script>